var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to ? 'router-link' : _vm.href ? 'a' : 'div',{tag:"component",class:[
    'icon',
    `icon-theme--${_vm.theme}`,
    `icon--size-${_vm.size}`,
    `icon-${_vm.name}`,
  ],attrs:{"to":_vm.to ? typeof _vm.to === 'string' ? _vm.$relativeUrl(_vm.to) : _vm.to : undefined},on:{"click":function($event){$event.stopPropagation();return _vm.fn.apply(null, arguments)}}},[_c('inline-svg',{attrs:{"src":require(`@/assets/svg/icons/${_vm.name}.svg`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }